export const StateScreen = {
  stInsert: 'INSER',
  stUpdate: 'UPDATE',
  stView: 'VIEW',
  stSearch: 'SEARCH',
};

export const PerfilUsuario = {
  administrador: 1,
  gerente: 2,
  gerenteSuporte: 5,
  gerenteProgramacao: 6,
  programador: 8,
};
